export default __webpack_public_path__ + "static/akitabox_logo.96fa2931aceb0c01d6ccda8610d47969.png";